(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-search"]) return;
  try {
    

const params = new URLSearchParams(window.location.search);
const searchTerm = params.get('q');

const searchInput = document.querySelector('.help-search-input');

if (searchTerm && searchInput) {
  searchInput.value = searchTerm;
}

const faqDataElement = document.getElementById('faq-data');
const resultsContainer = document.getElementById('faq-search-results');

if (faqDataElement && resultsContainer && searchTerm) {

  const faqs = JSON.parse(faqDataElement.textContent);

  const term = searchTerm.toLowerCase();

  const results = faqs.filter(faq =>
    faq.question.toLowerCase().includes(term) ||
    faq.answer.toLowerCase().includes(term) ||
    faq.note.toLowerCase().includes(term)
  );

if (typeof gtag === 'function') {

  gtag('event', 'help_search', {
    search_term: searchTerm,
    results_count: results.length
  });
}
if (results.length === 0 && typeof gtag === 'function') {

  gtag('event', 'help_search_no_results', {
    search_term: searchTerm
  });

}

  if (results.length > 0) {

    let html = `
      <h2>
        ${results.length} results for "${searchTerm}"
      </h2>
    `;

    results.forEach(faq => {

      html += `
        <a href="${faq.url}" class="faq-result">

          <div class="faq-result-category h6">
            ${faq.category}
          </div>

          <h4>
            ${faq.question}
          </h4>

          <p class="faq-result-preview">
            ${faq.answer.substring(0, 180)}...
          </p>

          <span class="faq-result-readmore">
            Read Article →
          </span>

        </a>
      `;

    });

    resultsContainer.innerHTML = html;

  } else {

    resultsContainer.innerHTML = `
      <p>
        No articles found for "${searchTerm}".
      </p>
    `;

  }

}

document.addEventListener('click', function(event) {

  const result = event.target.closest('.faq-result');

  if (!result) return;

  const title = result.querySelector('h4')?.innerText || '';

  if (typeof gtag === 'function') {

    gtag('event', 'help_article_click', {
      article_title: title
    });

  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
